// extracted by mini-css-extract-plugin
export default {"root":"sILHeR","itemClickWrapper":"UrH5ab","imageZoomBtn":"yewAS7","sizer":"v6gDrZ","imageWrapper":"Ry6CMm","imageBorder":"lhsOLD","image":"gdcwwX","overlay":"YbZRsC"};